import React, { PropsWithChildren, ReactElement } from 'react';

import { TSectionProperties } from './section.types';
import { StyledSection, StyledContainer } from './section.styled';

/**
 * The `Section` component adds space around themes of content as well as using background colour to break up the vertical flow of the page.
 *
 * The amount of space within the section is dependent on the screen size.
 */
export function Section({
    align = 'left',
    textAlign = 'left',
    backgroundColor = 'white',
    element = 'section',
    children,
    className,
    ...otherProperties
}: PropsWithChildren<TSectionProperties>): ReactElement {
    return (
        <StyledSection
            backgroundColor={backgroundColor}
            as={element}
            data-testid={element}
            className={className}
            {...otherProperties}
        >
            <StyledContainer align={align} textAlign={textAlign}>
                {children}
            </StyledContainer>
        </StyledSection>
    );
}
